<template>
    <div v-for="(coureurs, uuid) in inscriptions" :key="uuid">
        <div class="font-weight-bold mb-2">Commande n°{{ uuid }}</div>
        <div v-for="coureur in coureurs" :key="coureur.id" class="spo-card pa-3 rounded bordered">
            <div class="d-flex align-center ga-2">
                <v-chip v-if="coureur.supprime == '1'" size="small" color="red-darken-4"
                    variant="elevated">Supprimé</v-chip>
                <v-chip v-if="coureur.transfere == '1'" size="small" color="red-darken-4"
                    variant="elevated">Transféré</v-chip>
                <v-icon v-if="coureur.sexe == 'M'" icon="mdi-gender-male" color="light-blue-darken-4"
                    size="small"></v-icon>
                <v-icon v-else icon="mdi-gender-female" color="deep-purple" size="small"></v-icon>
                <span>{{ coureur.nom }} {{ coureur.prenom }}</span>
                <span class="text-medium-emphasis"> {{ getCourseName(coureur.id_course) }}</span>
            </div>
            <div class="d-flex align-center ga-2" v-if="coureur.prix_total_responsable > 0">
                <div>A la charge du responsable :</div>
                <div>{{ coureur.prix_total_responsable }}€ (Parcours : {{ coureur.prix_inscription_responsable }}€ -
                    Options : {{ coureur.prix_options_responsable }}€)</div>
            </div>


        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    computed: {
        ...mapStores(useMainStore),
    },
    props: {
        inscriptions: {
            type: Array,
            required: true,
        },
    },

    methods: {
        price_inscription_for_responsable_groupe(inscription) {
            const prix_inscription = inscription.prix_inscription;
            const prix_inscription_regulier = inscription.prix_inscription_regulier;
            const prix_responsable = parseFloat(prix_inscription_regulier) - parseFloat(prix_inscription);
            return prix_responsable;
        },
        price_options_for_responsable_groupe(inscription) {
            const prix_options = inscription.options_prix_sum;
            const prix_options_regulier = inscription.options_prix_regulier_sum;
            const prix_responsable = parseFloat(prix_options_regulier) - parseFloat(prix_options);
            return prix_responsable;
        },
        price_total_for_responsable_groupe(inscription) {
            return this.price_inscription_for_responsable_groupe(inscription) + this.price_options_for_responsable_groupe(inscription);
        },
        getCourseName(id_course) {
            if (!this.mainStore.module?.courses?.list) return id_course;
            const course = this.mainStore.module.courses.list.find((c) => c.id == id_course);
            return course ? course.nom : id_course;
        },
    },
}
</script>

<style lang="scss" scoped></style>